import React from "react";
import { View, Text } from "@src/components";
import { Icon } from "@src/components/Icon";
import { reportError } from "@visioni/a3s-error-reporting";

export class LivestreamErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean; error: Error | null }
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("[Livestream] Error Boundary caught error:", error.message);
    // A boundary keeps the error from Sentry's global handler, so report it here.
    reportError(error, { tags: { boundary: "livestream" }, extra: { componentStack: info.componentStack } });
  }

  render() {
    if (this.state.hasError) {
      return (
        <View style={{ flex: 1, justifyContent: "center", alignItems: "center", backgroundColor: "black" }}>
          <Icon name="errorOutline" size={64} color="white" style={{ marginBottom: 16 }} />
          <Text textStyle="md/regular" style={{ color: "white", textAlign: "center" }}>
            Something went wrong
          </Text>
          <Text textStyle="sm/regular" style={{ color: "gray", textAlign: "center", marginTop: 8 }}>
            An unexpected error occurred while loading the live stream.
          </Text>
        </View>
      );
    }

    return this.props.children;
  }
}
